export { Badge, Dot, badgeVariants } from './Badge'
export type { BadgeProps, BadgeVariant } from './Badge'
